<template>
  <div
    class="m-flex-clounm m-sec-detail"
    style="margin-top: 93px; padding-top: 0px"
  >
    <h3 class="m-form-title">选择顾问</h3>
    <div class="select-agent" v-loading="loading">
      <div>
        <div class="province-and-city">
          <div class="province-content flex-center">
            <div class="province-title">选择省份</div>
            <div class="select-province">
              <input
                class="input-pro"
                placeholder="请选择省份"
                v-model="agentPro"
                @click.stop="showProInfo"
                readonly
              />
              <img
                src="../../assets/images/open-province.png"
                class="collpose-img"
              />
              <div
                class="flex-row select-pro-div"
                v-show="showProDiv"
                @click.stop=""
              >
                <div class="select-pro-title">省份选择：</div>
                <table>
                  <template v-for="(item, index) in areaData">
                    <tr align="left" v-if="index % 3 === 0" :key="index">
                      <td>
                        <div
                          :class="[
                            'td-cell',
                            {
                              active: agentPro == item.province,
                            },
                          ]"
                          @click="selectProvince(item)"
                        >
                          {{ item.province }}
                        </div>
                      </td>
                      <td>
                        <div
                          :class="[
                            'td-cell',
                            {
                              active: agentPro == areaData[index + 1].province,
                            },
                          ]"
                          @click="selectProvince(areaData[index + 1])"
                          v-if="index + 1 < areaData.length"
                        >
                          {{ areaData[index + 1].province }}
                        </div>
                      </td>
                      <td>
                        <div
                          :class="[
                            'td-cell',
                            {
                              active: agentPro == areaData[index + 2].province,
                            },
                          ]"
                          @click="selectProvince(areaData[index + 2])"
                          v-if="index + 2 < areaData.length"
                        >
                          {{ areaData[index + 2].province }}
                        </div>
                      </td>
                    </tr>
                  </template>
                </table>
              </div>
            </div>
          </div>
          <div class="city-content flex-row">
            <div style="flex-shrink: 0; margin-top: 1px">选择地区</div>
            <div class="city-content-inner">
              <div
                :class="[
                  'city-item',
                  { 'current-city-item': agentCity == cityObj.name },
                ]"
                v-for="(cityObj, index) in cityData"
                :key="cityObj.id"
                @click.stop="selectCity(cityObj)"
              >
                <span>{{ cityObj.name || "全部" }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="agent-list" v-if="agentData && agentData.length > 0">
          <template v-for="(agent, index) in agentData">
            <div
              class="broker-item"
              :class="{ 'broker-active': agentId == agent.id }"
              :key="index"
              @click="getAgentId(agent.id, agent.idCard, agent.type)"
            >
              <img
                class="check-icon"
                v-if="agentId == agent.id"
                src="../../assets/icons/checked.png"
              />
              <img
                class="check-icon"
                v-else
                src="../../assets/icons/un_check.png"
              />
              <div class="broker-avator">
                <avatar
                  width="48"
                  :url="agent.avator | imgcrop(48, 48)"
                  :star="agent.star"
                ></avatar>
                <!-- <img :src="agent.avator | imgcrop(48, 48)" /> -->
              </div>
              <div class="broker-info">
                <div class="broker-name">
                  {{ agent.name }}
                </div>
                <div class="broker-city">{{ agent.cityName }}</div>
              </div>
            </div>
          </template>
        </div>

        <div class="no-data" v-else>暂无顾问</div>
      </div>
      <div class="m-form-input" style="width: 346px; margin-top: 24px">
        <div class="m-error" style="width: 100%; top: -30px">
          {{ errorInfo }}
        </div>
        <a class="m-all-btn" href="javascript:void(0)" @click="nextClick"
          >下一步</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import avatar from "./avatar.vue";
import api from "../../config/api.js";
export default {
  name: "select-agent",
  props: ["allData", "areaData", "currentProvinceInfo"],
  components: {
    avatar,
  },
  data: function () {
    return {
      agentData: [],
      loading: false,
      agentPro: "",
      agentCity: "",
      agentId: "",
      agentList: [],
      firData: this.allData,
      comButton: false,
      errorInfo: "",
      showProDiv: false,
      idCard: "", // 是否需要身份证
      agentType: "", // 支付流程类型   0:普通流程，1: 中金流程
    };
  },
  computed: {
    cityData() {
      let result = [];
      this.areaData.forEach((item) => {
        if (item.province == this.agentPro) {
          result = item.citys || [];
        }
      });
      console.log("cityData", result);
      return result;
    },
    currentProvince() {
      let result = {};
      console.log(this.areaData.length);
      this.areaData.forEach((item) => {
        if (item.province == this.agentPro) {
          result = item || [];
        }
      });
      console.log("currentProvince", result);
      return result;
    },
    currentCity() {
      let result = {};
      this.cityData.forEach((item) => {
        if (item.name == this.agentCity) {
          result = item || [];
        }
      });
      console.log("currentCity", result);
      return result;
    },
  },

  created: function () {
    console.log("allData", this.allData);
    this.agentData = [];
    this.errorInfo = "";
    this.showProDiv = false;
    if (this.allData[1]) {
      this.agentPro = this.allData[1].agentPro;
      this.agentCity = this.allData[1].agentCity;
      this.agentId = this.allData[1].brokerId;
      this.getAgentInfo();
    } else {
      this.setProvin();
    }
  },

  methods: {
    showProInfo(visible = true) {
      this.showProDiv = visible;
    },
    setProvin() {
      console.log(this.currentProvinceInfo);
      if (this.currentProvinceInfo) {
        this.areaData.forEach((item) => {
          if (item.province == this.currentProvinceInfo.provinceName) {
            this.agentPro = this.currentProvinceInfo.provinceName;
          }
        });
      }
      console.log(this.agentPro);
      if (!this.agentPro) {
        this.agentPro = "四川省";
      }
      this.agentCity = "";
      this.getAgentInfo();
    },
    selectCity(item) {
      //切换省份
      this.agentCity = item.name;
      this.errorInfo = "";
      this.getAgentInfo();
      // if (this.agentData && this.agentData.length > 0) {
      //   this.agentId = this.agentData[0].id;
      //   this.idCard = this.agentData[0].idCard; // 是否需要身份证
      // } else {
      //   this.agentId = "";
      //   this.idCard = ""; // 是否需要身份证
      // }
    },
    selectProvince(item) {
      //切换省份
      this.agentPro = item.province;
      this.agentCity = "";
      this.errorInfo = "";
      this.getAgentInfo();
      this.showProInfo(false);
      // if (this.agentData && this.agentData.length > 0) {
      //   this.agentId = this.agentData[0].id;
      //   this.idCard = this.agentData[0].idCard; // 是否需要身份证
      // } else {
      //   this.agentId = "";
      //   this.idCard = ""; // 是否需要身份证
      // }
    },
    chanPro: function (item, index) {
      //切换省份
      this.agentPro = item.cnName;
      this.errorInfo = "";
      if (this.agentData && this.agentData.length > 0) {
        this.agentId = this.agentData[0].id;
        this.idCard = this.agentData[0].idCard; // 是否需要身份证
      } else {
        this.agentId = "";
        this.idCard = ""; // 是否需要身份证
      }
      this.getAgentInfo();
    },
    getAgentInfo: function () {
      if (!this.currentProvince.provinceId) {
        return;
      }
      //获取顾问信息
      let vm = this;
      this.loading = true;
      // let url = api.API_URL + "wedding/broker/v2/query/province/broker/list";
      let str = "";
      if (!this.currentCity.name) {
        str = `?provinceId=${this.currentProvince.provinceId}`;
      } else {
        str = `?provinceId=${this.currentProvince.provinceId}&cityId=${this.currentCity.id}`;
      }
      let url = api.API_URL + "wedding/broker/v2/query/broker/by/address" + str;
      // /v1/query/broker/by/address
      vm.getAjax(
        url,
        "",
        function (result) {
          console.log("result", result);
          vm.loading = false;
          if (result.rcode == "000000" && result.rdata) {
            vm.agentData = result.rdata;
            //选中顾问
            if (vm.firData && vm.firData.length > 1) {
              let tempData = vm.firData[1];
              if (tempData.brokerId) {
                vm.agentId = tempData.brokerId; //顾问ID
                vm.idCard = tempData.idCard; // 是否需要身份证
                // vm.agentPro = tempData.agentPro;
                // vm.agentCity = tempData.agentCity;
              }
              if (vm.agentData && vm.agentData.length == 0) {
                vm.agentId = "";
              }
              // //设置agentData 根据前面选择的是哪个城市
              // for (let i = 0; i < vm.agentList.length; i++) {
              //   if (vm.agentList[i].cnName == vm.agentPro) {
              //     vm.agentData = vm.agentList[i].brokers;
              //     break;
              //   }
              // }
            } else {
              vm.agentData = result.rdata || [];
              // vm.agentPro = vm.areaData[0].province; //
              // vm.agentCity = vm.areaData[0].citys[0].name; //
              if (vm.agentData && vm.agentData.length > 0) {
                vm.agentId = vm.agentData[0].id;
                vm.idCard = vm.agentData[0].idCard; // 是否需要身份证
                vm.agentType = vm.agentData[0].type;
              }
              if (vm.agentData && vm.agentData.length == 0) {
                vm.agentId = "";
              }
            }
          } else {
            this.agentData = [];
          }
        },
        function () {}
      );
    },
    getAgentId: function (agid, idCard, type) {
      this.agentId = agid;
      this.idCard = idCard;
      this.agentType = type;
    },
    nextClick: function () {
      //下一步
      if (this.agentId && this.agentId != null) {
        this.errorInfo = "";
        let obj = { cuindex: 2, menuIndex: 2 };
        this.bus.$emit("updateIndex", obj);
        let datainfo = {
          brokerId: this.agentId,
          agentPro: this.agentPro,
          agentCity: this.agentCity,
          idCard: this.idCard,
          brokerType: this.agentType,
        };
        //添加历史记录
        window.history.pushState("", null, "");
        this.bus.$emit("updateData", datainfo);
      } else {
        this.errorInfo = "请选择顾问";
      }
    },
  },
  mounted() {
    window.addEventListener("click", (event) => {
      console.log(event.target);
      this.showProInfo(false);
    });
  },
};
</script>
<style lang="scss" scoped>
.select-agent {
  width: 840px;
  margin: 22px auto 0px;
  padding-bottom: 40px;
  border-radius: 8px;
  border: 1px solid #efefef;
}

.broker-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px 8px 16px 14px;
  width: 191px;
  height: 80px;
  border-radius: 4px;
  border: 1px solid #efefef;
  box-sizing: border-box;
  cursor: pointer;
  margin-right: 10px;
  &:hover {
    background: #ffffff;
    border: 1px solid transparent;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.06);
  }
  .check-icon {
    display: block;
  }
  &.broker-active {
    border: 1px solid #a28b77;
    .check-icon {
      display: block;
    }
  }
  .check-icon {
    display: block;
  }
}
.agent-list {
  padding-left: 23px;
}
.agent-list .broker-item:nth-child(4n) {
  margin-right: 0px;
}
.agent-list .broker-item:nth-child(n + 5) {
  margin-top: 10px;
}

.check-icon {
  position: absolute;
  right: -1px;
  top: -1px;
  display: none;
  width: 32px;
  height: 24px;
}
.broker-avator {
  margin-right: 12px;
}
.broker-info {
  text-align: left;
}
.broker-name {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.9);
}
.broker-city {
  margin-top: 8px;
  font-size: 12px;
  color: #9394a3;
}
.province-and-city {
  width: 100%;
  margin: 0 auto;
}
.province-content {
  height: 56px;
  background: #f6f8fa;
  padding: 0px 28px;
  .province-title {
    margin-right: 24px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.9);
    line-height: 22px;
  }
  .input-pro {
    width: 188px;
    height: 37px;
    padding-left: 16px;
    line-height: 37px;
    background: rgba(255, 255, 255, 0);
    border-radius: 4px;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(71, 71, 71, 0.9);
    cursor: pointer;
  }
  .select-province {
    position: relative;
    .select-pro-div {
      position: absolute;
      left: 0px;
      top: 45px;
      padding: 20px 0px 20px 28px;
      flex-wrap: wrap;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      border: 1px solid #efefef;
      z-index: 9;
      .select-pro-title {
        margin-bottom: 15px;
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.9);
        line-height: 21px;
      }
      .td-cell {
        margin-bottom: 12px;
        min-width: 120px;
        max-width: 200px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.9);
        line-height: 18px;
        cursor: pointer;
        &.active {
          color: #a28b77;
        }
      }
    }
  }
  .collpose-img {
    width: 12px;
    height: 13px;
    position: absolute;
    top: 13px;
    right: 17px;
  }
}
.city-content {
  margin-top: 16px;
  padding-left: 28px;
}
.city-content-inner {
  display: flex;
  flex-wrap: wrap;
}
.city-item {
  cursor: pointer;
  margin-left: 24px;
}
.city-item span {
  font-size: 13px;
  font-weight: 400;
  color: rgba(71, 71, 71, 0.9);
  line-height: 17px;
}
.current-city-item {
  color: #a28b77;
  span {
    color: #a28b77;
  }
}

.no-data {
  width: 100%;
  height: 260px;
  /* background: #D8D8D8; */
  font-size: 15px;
  font-weight: 400;
  color: #9394a3;
  line-height: 255px;
  text-align: center;
}
.agent-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// select-agent.vue?95bd3c02